import flagIcon from "../../../assets/image/flag.svg";
import { StyledFlag } from "./Flag.Styled";

const Flag = ({ width }) => {
  return <StyledFlag width={width} src={flagIcon} />;
};

export default Flag;
